import UploadProgressBar from 'app/components/UploadProgressBar';

const VideoUploadProgressBar = props => {
  const {
    accessCodePage
  } = props;

  // this fileId matches the one in useAccessCodePageVideoUploadForm
  let fileId = accessCodePage.id + '-video';

  return <UploadProgressBar {...{ fileId }} />;
}

export default VideoUploadProgressBar;

